module.exports = "<ui-select multiple ng-model=\"$ctrl.value\" uis-open-close=\"$ctrl.updateValue(isOpen)\">\n  <ui-select-match placeholder=\"Spa Days\">\n    {{ $item.name }}\n  </ui-select-match>\n  <ui-select-choices repeat=\"day in $ctrl.days | filter: $select.search track by day.id\">\n    <span ng-bind=\"day.name\"></span>\n    <small ng-bind=\"day.category\"></small>\n  </ui-select-choices>\n</ui-select>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/days/views/day.select.html
// module id = 587
// module chunks = 0